import * as http from "./base";

const prefix = "/letters-templates-";

export async function fetchLettersTemplatesList({
  page,
  sort,
  search,
  page_size,
  queryString
}) {
  const qs = http.prepareQueryString({
    page,
    sort,
    search,
    page_size,
    queryString
  });

  return await http.get(`${prefix}list/?${qs}`);
}
export async function fetchProductCodesList({
  page,
  sort,
  search,
  page_size,
  queryString
}) {
  const qs = http.prepareQueryString({
    page,
    sort,
    search,
    page_size,
    queryString
  });

  return await http.get(`/product-codes-list?${qs}`);
}

export async function createLettersTemplate(data) {
  return await http.post(`${prefix}create`, data, { newErrorFormat: true });
}

export async function deleteLettersTemplate(id) {
  return await http.del(`${prefix}delete/${id}`);
}

export async function updateLettersTemplate(id, data) {
  return await http.patch(`${prefix}update/${id}`, data);
}

export async function fetchLettersTemplateById(id) {
  return await http.get(`${prefix}retrieve/${id}`);
}

export async function updateThumbnail(id) {
  return await http.post(`/thumbnails/${id}?letter=yes`);
}
